import styled from '@emotion/styled';

const StyledHour = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  text-align: center;
  white-space: nowrap;
`;

const StyledDayLayout = styled.div`
  display: flex;
  justify-content: center;
  min-width: 84px;
`;
export { StyledHour, StyledDayLayout };
